export default __webpack_public_path__ + "static/media/cp_geo_eu.6dd98b24.svg";